import React from "react";
import { Button } from "./IconToggleButton.styles";
import type { IconToggleButtonProps } from "./IconToggleButton.types";

/** Icon-only toggle button: native button (keyboard + focus), `aria-pressed`, tooltip from `label`. */
export const IconToggleButton: React.FC<IconToggleButtonProps> = ({ icon, label, pressed, onClick, className }) => (
  <Button type="button" aria-label={label} aria-pressed={pressed} title={label} onClick={onClick} className={className}>
    <span aria-hidden="true" style={{ display: "inline-flex" }}>
      {icon}
    </span>
  </Button>
);

export default IconToggleButton;
